var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo02Bb3Edcb660564E75F7Fec89Fbdb88B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 17,
    viewBox: "0 0 73 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7651 0H0V16.8275H72.7651V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0305035 14.5822L6.24946 2.14428C6.35349 1.93876 6.64782 1.93876 6.75185 2.14428L12.9708 14.5822C13.0647 14.77 12.9277 14.9882 12.7196 14.9882H0.281698C0.0736378 14.9882 -0.0633771 14.77 0.0305035 14.5822Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1577 5.19904C42.1577 7.00815 40.6911 8.47471 38.882 8.47471H38.1538C40.0339 8.47471 41.5462 10.0605 41.4219 11.9686C41.3102 13.7092 39.7853 15.0261 38.0422 15.0261H32.3307C30.5216 15.0261 29.055 13.5595 29.055 11.7504C29.055 9.94128 30.5216 8.47471 32.3307 8.47471H33.0589C31.1787 8.47471 29.6665 6.88889 29.7908 4.98083C29.9025 3.24024 31.4274 1.92337 33.1705 1.92337H38.882C40.6911 1.92337 42.1577 3.38994 42.1577 5.19904Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6405 2.58841L50.7666 8.46229H56.9222C57.1404 8.46229 57.318 8.63991 57.318 8.85812V14.6153C57.318 14.8335 57.1404 15.0111 56.9222 15.0111H44.6137C44.3954 15.0111 44.2178 14.8335 44.2178 14.6153V2.30677C44.2178 2.08856 44.3954 1.91095 44.6137 1.91095H56.3614C56.7141 1.91095 56.8917 2.33722 56.6405 2.58841Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.763 7.73409H69.1343C68.9567 7.73409 68.8121 7.87871 68.8121 8.05632V14.6889C68.8121 14.8665 68.6674 15.0111 68.4898 15.0111H62.5855C62.4079 15.0111 62.2632 14.8665 62.2632 14.6889V8.05632C62.2632 7.87871 62.1186 7.73409 61.941 7.73409H59.3124C59.1347 7.73409 58.9901 7.58946 58.9901 7.41185V2.23319C58.9901 2.05558 59.1347 1.91095 59.3124 1.91095H71.768C71.9456 1.91095 72.0903 2.05558 72.0903 2.23319V7.40931C72.0903 7.58692 71.9456 7.73155 71.768 7.73155L71.763 7.73409Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5879 5.20139C27.5879 7.0105 26.1214 8.47707 24.3122 8.47707H23.5839C25.4414 8.47707 26.9384 10.0248 26.8572 11.8999C26.7811 13.6227 25.2078 15.0259 23.4824 15.0259H17.7633C15.9542 15.0259 14.4877 13.5593 14.4877 11.7502C14.4877 9.9411 15.9542 8.47453 17.7633 8.47453H18.4916C16.6342 8.47453 15.1372 6.92677 15.2184 5.05169C15.2945 3.32885 16.8677 1.92572 18.593 1.92572H24.3122C26.1214 1.92572 27.5879 3.39229 27.5879 5.20139Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.849778 14.1859L7.07889 1.72767C7.18292 1.51961 7.47725 1.51961 7.58128 1.72767L13.8104 14.1859C13.9043 14.3736 13.7673 14.5918 13.5592 14.5918H1.10097C0.892913 14.5918 0.755898 14.3711 0.849778 14.1859Z",
    fill: "white",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8045 4.8108C42.8045 6.6199 41.3379 8.08647 39.5288 8.08647C39.5288 8.08647 42.193 9.67229 42.0686 11.5803C41.957 13.3209 40.4321 14.6378 38.6889 14.6378H32.9775C31.1683 14.6378 29.7018 13.1712 29.7018 11.3621C29.7018 9.55304 31.1683 8.08647 32.9775 8.08647C32.9775 8.08647 30.3133 6.50065 30.4376 4.59259C30.5492 2.85199 32.0742 1.53513 33.8173 1.53513H39.5288C41.3379 1.53513 42.8045 3.00169 42.8045 4.8108Z",
    fill: "white",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2873 2.19684L51.4134 8.07072H57.569C57.7872 8.07072 57.9648 8.24833 57.9648 8.46654V14.2237C57.9648 14.4419 57.7872 14.6195 57.569 14.6195H45.2604C45.0422 14.6195 44.8646 14.4419 44.8646 14.2237V1.91773C44.8646 1.69952 45.0422 1.52191 45.2604 1.52191H57.0082C57.3609 1.52191 57.5385 1.94818 57.2873 2.19937V2.19684Z",
    fill: "white",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4097 7.34251H69.7811C69.6035 7.34251 69.4588 7.48714 69.4588 7.66475V14.2973C69.4588 14.4749 69.3142 14.6195 69.1366 14.6195H63.2323C63.0547 14.6195 62.91 14.4749 62.91 14.2973V7.66475C62.91 7.48714 62.7654 7.34251 62.5878 7.34251H59.9591C59.7815 7.34251 59.6369 7.19788 59.6369 7.02027V1.84415C59.6369 1.66654 59.7815 1.52191 59.9591 1.52191H72.4148C72.5924 1.52191 72.7371 1.66654 72.7371 1.84415V7.02027C72.7371 7.19788 72.5924 7.34251 72.4148 7.34251H72.4097Z",
    fill: "white",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7037 5.45768L54.0042 5.45261",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6074 8.05624L51.4137 8.07147",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2047 4.80848C28.2047 6.61759 26.7381 8.08415 24.9289 8.08415C24.9289 8.08415 27.5932 9.66997 27.4689 11.578C27.3573 13.3186 25.8323 14.6355 24.0891 14.6355H18.3776C16.5685 14.6355 15.1019 13.1689 15.1019 11.3598C15.1019 9.55072 16.5685 8.08415 18.3776 8.08415C18.3776 8.08415 15.7134 6.49833 15.8377 4.59027C15.9494 2.84967 17.4743 1.53281 19.2175 1.53281H24.9289C26.7381 1.53281 28.2047 2.99938 28.2047 4.80848Z",
    fill: "white",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6412 7.34846L63.92 7.34338L70.0045 7.34592",
    stroke: "#141A1E",
    strokeWidth: 0.0634328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3553 14.5538C20.1504 14.5538 21.6056 13.1111 21.6056 11.3314C21.6056 9.55176 20.1504 8.10904 18.3553 8.10904C16.5603 8.10904 15.105 9.55176 15.105 11.3314C15.105 13.1111 16.5603 14.5538 18.3553 14.5538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9797 8.02027C26.7595 8.02027 28.2022 6.57756 28.2022 4.79788C28.2022 3.01821 26.7595 1.5755 24.9797 1.5755C23.2 1.5755 21.7573 3.01821 21.7573 4.79788C21.7573 6.57756 23.2 8.02027 24.9797 8.02027Z",
    fill: "#EFD165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9723 14.5538C34.752 14.5538 36.1947 13.1111 36.1947 11.3314C36.1947 9.55176 34.752 8.10904 32.9723 8.10904C31.1927 8.10904 29.7499 9.55176 29.7499 11.3314C29.7499 13.1111 31.1927 14.5538 32.9723 14.5538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5649 8.01253C41.3445 8.01253 42.7872 6.56981 42.7872 4.79014C42.7872 3.01047 41.3445 1.56775 39.5649 1.56775C37.7849 1.56775 36.3425 3.01047 36.3425 4.79014C36.3425 6.56981 37.7849 8.01253 39.5649 8.01253Z",
    fill: "#EFD165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3373 14.605C16.5358 14.605 15.0693 13.1384 15.0693 11.3369C15.0693 9.53542 16.5358 8.06631 18.3373 8.06631C20.1388 8.06631 21.6079 9.53288 21.6079 11.3369C21.6079 13.1409 20.1414 14.605 18.3373 14.605ZM18.3373 8.12721C16.5688 8.12721 15.1302 9.56587 15.1302 11.3344C15.1302 13.1029 16.5688 14.5415 18.3373 14.5415C20.1058 14.5415 21.5445 13.1029 21.5445 11.3344C21.5445 9.56587 20.1058 8.12721 18.3373 8.12721Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3657 8.23404L15.5313 9.67224L15.5527 9.72925L19.3871 8.29105L19.3657 8.23404Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3551 8.06631L16.179 8.88252L16.2003 8.93956L18.3765 8.12333L18.3551 8.06631Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.262 10.3929L15.2417 10.3346L19.9814 8.52292L20.0017 8.57874L15.262 10.3929Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1356 10.9892L15.1128 10.9334L20.4564 8.88321L20.4792 8.94157L15.1356 10.9892Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1277 11.5216L15.1074 11.4658L20.8595 9.32428L20.8823 9.38264L15.1277 11.5216Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1664 9.7265L15.1772 11.9729L15.1986 12.0299L21.1878 9.78352L21.1664 9.7265Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3482 12.5324L15.3279 12.474L21.3591 10.1955L21.3819 10.2539L15.3482 12.5324Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5023 10.656L15.5515 12.9462L15.5734 13.003L21.5241 10.7128L21.5023 10.656Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5455 11.1794L15.8481 13.3721L15.87 13.4289L21.5674 11.2362L21.5455 11.1794Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5401 11.6701L16.2278 13.768L16.2502 13.8247L21.5625 11.7267L21.5401 11.6701Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7616 14.1814L16.7388 14.123L21.415 12.2657L21.4378 12.3215L16.7616 14.1814Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4061 14.4746L17.3833 14.4163L21.1715 12.8558L21.1537 12.9294L17.4061 14.4746Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4259 14.602L18.4005 14.5462L20.5445 13.6657L20.5674 13.7215L18.4259 14.602Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9722 14.6019C31.1707 14.6019 29.7041 13.1353 29.7041 11.3338C29.7041 9.53234 31.1707 8.06323 32.9722 8.06323C34.7737 8.06323 36.2428 9.5298 36.2428 11.3338C36.2428 13.1379 34.7762 14.6019 32.9722 14.6019ZM32.9722 8.12413C31.2037 8.12413 29.765 9.56278 29.765 11.3313C29.765 13.0998 31.2037 14.5385 32.9722 14.5385C34.7407 14.5385 36.1793 13.0998 36.1793 11.3313C36.1793 9.56278 34.7407 8.12413 32.9722 8.12413Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0013 8.23016L30.1669 9.66836L30.1882 9.72538L34.0226 8.28718L34.0013 8.23016Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9884 8.06476L30.8122 8.88096L30.8335 8.938L33.0098 8.12177L32.9884 8.06476Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8968 10.3908L29.8765 10.3324L34.6162 8.51825L34.6391 8.57661L29.8968 10.3908Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7697 10.9861L29.7468 10.9277L35.0904 8.8801L35.1132 8.93592L29.7697 10.9861Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7625 11.5192L29.7422 11.4609L35.4943 9.32193L35.5171 9.37775L29.7625 11.5192Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7991 9.72263L29.8098 11.969L29.8313 12.0261L35.8204 9.77964L35.7991 9.72263Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.983 12.5293L29.9627 12.4709L35.9939 10.1924L36.0167 10.2508L29.983 12.5293Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1394 10.6544L30.1887 12.9447L30.2105 13.0015L36.1612 10.7113L36.1394 10.6544Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1834 11.1778L30.4861 13.3705L30.5079 13.4274L36.2054 11.2346L36.1834 11.1778Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1733 11.6685L30.8611 13.7664L30.8835 13.8231L36.1958 11.7252L36.1733 11.6685Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3972 14.1759L31.3744 14.1201L36.0507 12.2603L36.0735 12.3186L31.3972 14.1759Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.041 14.47L32.0181 14.4142L35.8063 12.8512L35.7886 12.9247L32.041 14.47Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0607 14.5999L33.0353 14.5415L35.1794 13.6611L35.2047 13.7194L33.0607 14.5999Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9804 8.06603C23.1789 8.06603 21.7123 6.59946 21.7123 4.79797C21.7123 2.99647 23.1789 1.52737 24.9804 1.52737C26.7818 1.52737 28.2509 2.99394 28.2509 4.79797C28.2509 6.602 26.7843 8.06603 24.9804 8.06603ZM24.9804 1.58827C23.2119 1.58827 21.7732 3.02692 21.7732 4.79543C21.7732 6.56394 23.2119 8.00259 24.9804 8.00259C26.7488 8.00259 28.1875 6.56394 28.1875 4.79543C28.1875 3.02692 26.7488 1.58827 24.9804 1.58827Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0095 1.69662L22.1751 3.13482L22.1965 3.19184L26.0308 1.75364L26.0095 1.69662Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9958 1.52969L22.8196 2.34592L22.841 2.40293L25.0172 1.58671L24.9958 1.52969Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9042 3.85394L21.8839 3.79812L26.6237 1.98395L26.6466 2.03977L21.9042 3.85394Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7778 4.4502L21.755 4.39438L27.0985 2.34424L27.1213 2.4026L21.7778 4.4502Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7699 4.98339L21.7496 4.92756L27.5016 2.78607L27.5244 2.84443L21.7699 4.98339Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8072 3.18677L21.8179 5.43318L21.8393 5.49019L27.8285 3.24381L27.8072 3.18677Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9904 5.99342L21.9701 5.93506L28.0012 3.65656L28.024 3.71491L21.9904 5.99342Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.147 4.11935L22.1961 6.40961L22.218 6.46645L28.1688 4.17619L28.147 4.11935Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1901 4.63959L22.4927 6.83233L22.5145 6.88917L28.2119 4.69642L28.1901 4.63959Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1807 5.13269L22.8685 7.23059L22.8909 7.28722L28.2033 5.18932L28.1807 5.13269Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4039 7.64239L23.381 7.58403L28.0572 5.72672L28.08 5.78254L23.4039 7.64239Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0817 7.92645L24.0589 7.87063L27.8064 6.32541L27.8292 6.38123L24.0817 7.92645Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0689 8.0638L25.0435 8.00798L27.1875 7.12753L27.2129 7.18335L25.0689 8.0638Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5795 8.08852C37.778 8.08852 36.3114 6.62196 36.3114 4.82046C36.3114 3.01897 37.778 1.54987 39.5795 1.54987C41.381 1.54987 42.8501 3.01643 42.8501 4.82046C42.8501 6.62449 41.3835 8.08852 39.5795 8.08852ZM39.5795 1.61076C37.811 1.61076 36.3723 3.04942 36.3723 4.81793C36.3723 6.58643 37.811 8.02509 39.5795 8.02509C41.348 8.02509 42.7866 6.58643 42.7866 4.81793C42.7866 3.04942 41.348 1.61076 39.5795 1.61076Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6078 1.71606L36.7734 3.15426L36.795 3.21127L40.6291 1.77308L40.6078 1.71606Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5981 1.54834L37.4218 2.36456L37.4434 2.42158L39.6194 1.60536L39.5981 1.54834Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5067 3.87666L36.4838 3.8183L41.2235 2.00412L41.2464 2.06248L36.5067 3.87666Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3775 4.47295L36.3572 4.41459L41.6983 2.36444L41.7211 2.4228L36.3775 4.47295Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3723 5.00612L36.3495 4.94777L42.1041 2.80627L42.1244 2.86463L36.3723 5.00612Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4084 3.20926L36.4194 5.45567L36.4407 5.51268L42.4298 3.26627L42.4084 3.20926Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5936 6.01591L36.5708 5.95755L42.6045 3.67905L42.6248 3.73487L36.5936 6.01591Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7459 4.13797L36.7952 6.42823L36.817 6.48504L42.7677 4.19481L42.7459 4.13797Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7907 4.66446L37.0934 6.85718L37.1152 6.91402L42.8127 4.72127L42.7907 4.66446Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7844 5.1521L37.4723 7.25L37.4946 7.30663L42.8067 5.20873L42.7844 5.1521Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0037 7.66256L37.9809 7.60674L42.6597 5.74689L42.6825 5.80525L38.0037 7.66256Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6809 7.94916L38.658 7.89081L42.4056 6.34558L42.4285 6.40394L38.6809 7.94916Z",
    fill: "#141A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6686 8.08651L39.6458 8.02815L41.7898 7.14771L41.8126 7.20606L39.6686 8.08651Z",
    fill: "#141A1E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.8209,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02Bb3Edcb660564E75F7Fec89Fbdb88B);
export default __webpack_public_path__ + "static/media/logo.02bb3edcb660564e75f7fec89fbdb88b.02bb3edcb660564e75f7fec89fbdb88b.svg";
export { ForwardRef as ReactComponent };